module.exports = __webpack_public_path__ + "img/truckCheck.bf1bb012.png";